import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useResidentEnvironments } from '~/hooks/environment/useResidentEnvironments';
import { zoomToCursorState } from '~/state/atoms/toolsAtoms';

/**
 * Applies the zoom-to-cursor preference to every Environment the open
 * surface draws, for as long as it is mounted, so a zoom lands where the
 * option says on every tile. A resident that joins later receives the
 * current value through the registry lifecycle, and a fresh Environment
 * defaults to cursor-focused zoom until then. The value is a preference,
 * not a state: nothing is restored on unmount.
 */
export function useZoomToCursor(): void {
    const residents = useResidentEnvironments();
    const zoomToCursor = useRecoilValue(zoomToCursorState);

    useEffect(() => {
        for (const environment of residents) {
            environment.panZoom.setZoomToCursor(zoomToCursor);
        }
    }, [residents, zoomToCursor]);
}
